// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"657":"cc8c23b5","869":"5ef3e3cb"}[chunkId] + ".chunk.css";
};